export class ActionTypeCreator {
  constructor(prefix) {
    this.prefix = prefix;
  }

  simple(name) {
    return `${this.prefix}_${name}`;
  }

  RSAA(name) {
    return {
      REQUEST: this.simple(`${name}_REQUEST`),
      SUCCESS: this.simple(`${name}_SUCCESS`),
      FAILURE: this.simple(`${name}_FAILURE`),
    };
  }
}
